import {View} from '@fantasmagames/slot/src/common/view/View';
import {GamePrototypeWinLine} from 'src/logic/prototype/GamePrototypeLogic';

export class WinLinesPresentationView extends View {

	public static readonly LINES_PRESENTATION_FINISHED: string = 'WinLinesPresentationView::LINES_PRESENTATION_FINISHED';

	protected _currentWinLines: GamePrototypeWinLine[];
	protected _currentWinLineIndex: number;

	public playWinPresentation(lines: GamePrototypeWinLine[]): void {
		this._currentWinLines = lines;
		this._currentWinLineIndex = -1;

		this.playNextLine();
	}

	protected playNextLine(): void {
		this._currentWinLineIndex++;
		if (this._currentWinLineIndex >= this._currentWinLines.length) {
			this.emitDelayed(WinLinesPresentationView.LINES_PRESENTATION_FINISHED);
		} else {
			this.playLine(this._currentWinLines[this._currentWinLineIndex], this.playNextLine.bind(this));
		}
	}

	protected playLine(line: GamePrototypeWinLine, onFinished: Function): void {
		// this.spineUtils.startSpineAnimationCreation('WINLINES.json', this.getAnimationNameForLine(line), false)
	}

	protected getAnimationNameForLine(line: GamePrototypeWinLine): string {
		const direction: string = line.isRightToLeft ? 'RIGHT_TO_LEFT' : 'LEFT_TO_RIGHT';

		return `WINLINE_${line.lineIndex}_${direction}`;
	}

}



// WEBPACK FOOTER //
// ./src/winlinespresentation/WinLinesPresentationView.ts